import type { ExtendedSubFlow } from '@withdrawals/types'
import { paths, WithdrawalSubFlows } from 'mmfintech-backend-api'

type SupportedSubFlow = {
  key: ExtendedSubFlow
  title: string
  titleKey: string
  description?: string
  descriptionKey?: string
  path?: string
  dataTest?: string
}

export const SUPPORTED_SUBFLOWS: SupportedSubFlow[] = [
  {
    key: WithdrawalSubFlows.BANKWIRE,
    title: 'Bank transfer',
    titleKey: 'FRONTEND.SEND_MONEY.FLOWS.BANKWIRE',
    description: 'Send funds',
    descriptionKey: 'FRONTEND.SEND_MONEY.FLOWS.BANKWIRE_DESC',
    // path: getFlowPath(WithdrawalSubFlows.BANKWIRE),
    dataTest: 'bank-transfer-button'
  },

  // REMITTANCE

  {
    key: WithdrawalSubFlows.CRYPTO,
    title: 'Crypto transfer',
    titleKey: 'FRONTEND.SEND_MONEY.FLOWS.CRYPTO',
    description: "Send crypto to a recipient's address",
    descriptionKey: 'FRONTEND.SEND_MONEY.FLOWS.CRYPTO_DESC',
    // path: getFlowPath(WithdrawalSubFlows.CRYPTO),
    dataTest: 'send-crypto-button'
  },

  {
    key: WithdrawalSubFlows.INTERNAL_TRANSFER,
    title: 'Kingdom Bank user',
    titleKey: 'FRONTEND.SEND_MONEY.FLOWS.INTERNAL_TRANSFER',
    description: 'Send funds to another Kingdom Bank user',
    descriptionKey: 'FRONTEND.SEND_MONEY.FLOWS.INTERNAL_TRANSFER_DESC',
    // path: getFlowPath(WithdrawalSubFlows.INTERNAL_TRANSFER),
    dataTest: 'internal-transfer-button'
  },

  {
    key: WithdrawalSubFlows.JETON_WALLET,
    title: 'Jeton wallet',
    titleKey: 'FRONTEND.SEND_MONEY.FLOWS.JETON_WALLET',
    description: 'Send money to Jeton wallet',
    descriptionKey: 'FRONTEND.SEND_MONEY.FLOWS.JETON_WALLET_DESC',
    // path: getFlowPath(WithdrawalSubFlows.JETON_WALLET),
    dataTest: 'digital-wallet-button'
  },

  // JETON_BANK_WALLET
  // KINGDOM_WALLET

  {
    key: WithdrawalSubFlows.BATCH,
    title: 'Batch payment',
    titleKey: 'FRONTEND.SEND_MONEY.FLOWS.BATCH',
    description: 'Make a one click mass payment',
    descriptionKey: 'FRONTEND.SEND_MONEY.FLOWS.BATCH_DESC',
    path: paths.banking.sendBatchPayment(), // paths.banking.batchPayment(),
    dataTest: 'batch-payment-button'
  },

  {
    key: WithdrawalSubFlows.INTRA_ACCOUNT_TRANSFER,
    title: 'Between own accounts',
    titleKey: 'FRONTEND.SEND_MONEY.FLOWS.INTRA_ACCOUNT_TRANSFER',
    description: 'Transfer funds between your accounts',
    descriptionKey: 'FRONTEND.SEND_MONEY.FLOWS.INTRA_ACCOUNT_TRANSFER_DESC',
    // path: getFlowPath(WithdrawalSubFlows.INTRA_ACCOUNT_TRANSFER),
    dataTest: 'transfer-between-accounts-button'
  },

  {
    key: WithdrawalSubFlows.PIX,
    title: 'PIX transfer',
    titleKey: 'FRONTEND.SEND_MONEY.FLOWS.PIX',
    description: 'Send money to a PIX account',
    descriptionKey: 'FRONTEND.SEND_MONEY.FLOWS.PIX_DESC',
    // path: getFlowPath(WithdrawalSubFlows.PIX),
    dataTest: 'pix-transfer-button'
  },

  {
    key: WithdrawalSubFlows.INTERAC,
    title: 'Interac transfer',
    titleKey: 'FRONTEND.SEND_MONEY.FLOWS.INTERAC',
    description: 'Send money to an Interac account',
    descriptionKey: 'FRONTEND.SEND_MONEY.FLOWS.INTERAC_DESC',
    // path: getFlowPath(WithdrawalSubFlows.INTERAC),
    dataTest: 'interac-transfer-button'
  },

  {
    key: WithdrawalSubFlows.PERFECT_MONEY,
    title: 'Perfect Money transfer',
    titleKey: 'FRONTEND.SEND_MONEY.FLOWS.PERFECT_MONEY',
    description: 'Send money to a Perfect Money account',
    descriptionKey: 'FRONTEND.SEND_MONEY.FLOWS.PERFECT_MONEY_DESC',
    // path: getFlowPath(WithdrawalSubFlows.PERFECT_MONEY),
    dataTest: 'perfect-money-transfer-button'
  },

  // CASH

  {
    key: WithdrawalSubFlows.SKRILL,
    title: 'Skrill transfer',
    titleKey: 'FRONTEND.SEND_MONEY.FLOWS.SKRILL',
    description: 'Send money to a Skrill account',
    descriptionKey: 'FRONTEND.SEND_MONEY.FLOWS.SKRILL_DESC',
    // path: getFlowPath(WithdrawalSubFlows.SKRILL),
    dataTest: 'skrill-transfer-button'
  },

  // ZIMPLER
  // SKRILL_1_TAP

  {
    key: WithdrawalSubFlows.PAY_TO_CARD,
    title: 'Send to card',
    titleKey: 'FRONTEND.SEND_MONEY.FLOWS.PAY_TO_CARD',
    description: 'Send funds to a bank card',
    descriptionKey: 'FRONTEND.SEND_MONEY.FLOWS.PAY_TO_CARD_DESC',
    // path: getFlowPath(WithdrawalSubFlows.PAY_TO_CARD),
    dataTest: 'pay-to-card-button'
  },

  // PAY_TO_MOBILE
  // TRUSTLY

  {
    key: WithdrawalSubFlows.MASTERCARD,
    title: 'Send money abroad',
    titleKey: 'FRONTEND.SEND_MONEY.FLOWS.MASTERCARD',
    description: 'Global transfers powered by Mastercard',
    descriptionKey: 'FRONTEND.SEND_MONEY.FLOWS.MASTERCARD_DESC',
    // path: getFlowPath(WithdrawalSubFlows.MASTERCARD),
    dataTest: 'mastercard-button'
  },

  {
    key: 'SUB_ACCOUNTS',
    title: 'Between linked accounts',
    titleKey: 'FRONTEND.SEND_MONEY.FLOWS.SUB_ACCOUNTS',
    description: 'Transfer between your linked accounts',
    descriptionKey: 'FRONTEND.SEND_MONEY.FLOWS.SUB_ACCOUNTS_DESC',
    // path: getFlowPath('SUB_ACCOUNTS'),
    dataTest: 'transfer-linked-accounts-button'
  }
] as const
